import PropTypes from 'prop-types'
import { forwardRef } from 'react'

import LauncherShell from './launcher/LauncherShell'
import clipVariant, { ClipAvatar } from './launcher/variants/clip'

/**
 * Floating Assistant-Launcher unten rechts in der Variante "Karl Klammer".
 *
 * Beim ersten Mal steht Karl Klammer (1997) da, damit jeder erkennt was gemeint ist.
 * Danach wickelt sich der Draht ab und landet als moderne Aivy-Klammer im Button.
 * Die Klammer ist der Button und oeffnet den Chat als Popout (children).
 */
const AssistantLauncher = forwardRef(function AssistantLauncher(props, ref) {
  return <LauncherShell ref={ref} variant={clipVariant} {...props} />
})

AssistantLauncher.propTypes = {
  intro: PropTypes.oneOf(['once', 'always', 'never']),
  title: PropTypes.string,
  subtitle: PropTypes.string,
  userName: PropTypes.string,
  tooltipText: PropTypes.string,
  thinking: PropTypes.bool,
  defaultOpen: PropTypes.bool,
  onOpenChange: PropTypes.func,
  children: PropTypes.node
}

export { ClipAvatar }
export default AssistantLauncher
